//余课表--王颖忠
<template>
    <vue-scroll :ops="$ops" >
        <div class=" card-body" :style="{'height':(clientHeight)*3/5+'px'}" v-if="isMounted">
            <!--<div class="card card-body">-->
            <el-row :gutter="24">
                <el-col :span="16">
                    <div>
                        <el-row :gutter="20">
                            <el-col :span="3" v-for="subject in $parentInfo.insufficientCourse.subjects">
                                <el-checkbox-group v-model="$parentInfo.insufficientCourse.subject_id">
                                    <el-checkbox @change="handleShowInsufficientCourses()"
                                                 :label="subject.id"
                                                 :key="subject.id"
                                                 border>{{subject.name}}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-col>
                        </el-row>

                    </div>
                </el-col>
                <el-col :span="8">
                    <span>教师：</span>
                    <el-input
                            placeholder="请输入教师"
                            v-model="$parentInfo.insufficientCourse.teacherName"
                            @change="handleShowInsufficientCourses()"
                            style="width:150px;">
                    </el-input>
                </el-col>
            </el-row>
            <table class="table table-striped" v-loading="$parentInfo.insufficientCourse.loading">
                <thead>
                <tr>
                    <th>校区</th>
                    <th>科目</th>
                    <th>班名</th>
                    <th>班型</th>
                    <th>人数</th>
                    <th>教师</th>
                    <th>上课人数</th>
                    <th>课时/剩余</th>
                    <th>上课时间</th>
                    <th>单价</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in $parentInfo.insufficientCourse.insufficientCourses" style="height: 50px">
                    <td>{{item.section.name}}</td>
                    <td>{{item.subject.name}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.class_type.name}}</td>
                    <td>{{item.class_type.num}}</td>
                    <td>{{item.teacher}}</td>
                    <td>{{item.student_num}}</td>
                    <!--<td>{{item.period}}/{{item.rest_class.restClass}}</td>-->
                    <td>{{item.remainder}}</td>
                    <td>
                        {{item.time}}
                    </td>
                    <td>{{item.unit_period_price}}</td>
                </tr>
                </tbody>
            </table>
            <!--分页-->
            <div class="text-center m-t-10">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="$parentInfo.insufficientCourse.currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="$parentInfo.insufficientCourse.total">
                </el-pagination>
            </div>
        </div>
    </vue-scroll>
</template>

<script>
    export default {
        name: "InsufficientCourses",
        data() {
            return {
                isMounted:false,
            }
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowInsufficientCourses();
            this.isMounted=true;
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            right_level() {
                return this.$store.state.user.employee.right_level;
            }
        },
        methods: {
            //找到余课视图中的信息
            handleShowInsufficientCourses(currentPage = 1, currentPageSize = 10) {
                this.$wApi.send(this.$parentInfo.path, 'insufficient_courses',
                    {'currentPage':currentPage,'currentPageSize':currentPageSize,'student_id':this.$parentInfo.student_id,
                        'teacherName':this.$parentInfo.insufficientCourse.teacherName,'subject_id':this.$parentInfo.insufficientCourse.subject_id})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleShowInsufficientCourses(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleShowInsufficientCourses(this.currentPage, this.currentPageSize)
            }
        },


    }
</script>

<style scoped>

</style>